import { motion } from 'framer-motion';
import styles from './ScrollingTextBar.module.css';

const ScrollingTextBar = () => {
  const message = "Believe you can and you will! Shine your light into the world and lift up those around you. || Believe you can and you will! Shine your light into the world and lift up those around you. || Believe you can and you will! Shine your light into the world and lift up those around you. || Believe you can and you will! Shine your light into the world and lift up those around you. || Believe you can and you will! Shine your light into the world and lift up those around you.";

  return (
    <div className={styles.bar}>
      <motion.div
        className={styles.scrollingText}
        animate={{ x: ['5%', '-50%'] }}
        transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: 30,
        }}
      >
        <span>{message}</span>
      </motion.div>
    </div>
  );
};

export default ScrollingTextBar;